import type { AxiosResponse } from 'axios';
import { isNullOrEmpty } from '@/lib/isNullOrEmpty.ts';

function wrapInstance<DT>(
  instance: Response,
  domain: DT,
): ServiceSuccessResponse<DT> {
  return Object.assign(instance, { domain: domain });
}

export interface ServiceSuccessResponse<TDomain> extends Partial<Response> {
  readonly domain: TDomain;
}

export function fromAxios<TDomain, TData>(
  domain: TDomain,
  axiosResponse: AxiosResponse<TData>,
): ServiceSuccessResponse<TDomain> {
  const response = isNullOrEmpty(axiosResponse.data)
    ? new Response(null, { status: axiosResponse.status })
    : Response.json(axiosResponse.data, {
        status: axiosResponse.status,
      });
  return wrapInstance(response, domain);
}
